// WithDrawRequestContext.js
import { TOKEN_KEY } from 'api';
import { getAll, getMe } from 'api/requests';
import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const WithDrawRequestContext = createContext();

export const WithDrawRequestProvider = ({ children }) => {
  const { isLoggedIn, user } = useAuth();

  const [state, setState] = useState({
    isLoading: true,
    data: []
  });

  const getAllRequests = async () => {
    try {
      const { data } = await getAll();

      setState({
        isLoading: false,
        data: data.withdrawRequests
      });
    } catch (err) {
      console.error(err);
    } finally {
      setState(st => ({
        ...st,
        isLoading: false
      }));
    }
  };

  const updateRequest = ({ id, body }) => {
    setState(st => ({
      ...st,
      data: st.data.map(request => {
        if (request.id === id) {
          return {
            ...request,
            ...body
          };
        }
        return request;
      })
    }));
  };

  const getMyRequests = async () => {
    try {
      const { data } = await getMe();

      setState({
        isLoading: false,
        data: data.withdrawRequests
      });
    } catch (err) {
      console.error(err);
    } finally {
      setState(st => ({
        ...st,
        isLoading: false
      }));
    }
  };

  const addRequest = request => {
    setState(st => ({
      ...st,
      data: [request, ...st.data]
    }));
  };

  const deleteGame = id => {
    setState(st => ({
      ...st,
      data: st.data.filter(request => request.id !== id)
    }));
  };

  useEffect(() => {
    if (!isLoggedIn || !user) return;

    if (user.role === 'admin') getAllRequests();
    else getMyRequests();
  }, [isLoggedIn, user]);

  return (
    <WithDrawRequestContext.Provider
      displayName='Withdraw Context'
      value={{
        isLoading: state.isLoading,
        data: state.data,
        deleteGame,
        addRequest,
        updateRequest
      }}
    >
      {children}
    </WithDrawRequestContext.Provider>
  );
};

export const useWithdrawRequests = () => useContext(WithDrawRequestContext);
